import { generatePath } from 'react-router';
import { all, call, takeEvery } from 'redux-saga/effects';

import { PATH } from 'constants/RoutesConstants';

import { simpleRequestsLoader } from 'modules/app/utils';
import * as actionTypes from 'modules/leads/actionTypes';
import requestsConfig from 'modules/leads/requestsConfig';
import type { CreateDirectMessageSuccessAction } from 'modules/leads/types';
import { navigate } from 'modules/router/navigate';

function* navigateToDirectMessage({ payload }: CreateDirectMessageSuccessAction) {
  yield call(navigate, generatePath(PATH.SALES_DETAILED.path, { interventionId: payload.intervention.id }));
}

export default function* coreSaga() {
  yield all(simpleRequestsLoader(requestsConfig));
  yield takeEvery(actionTypes.CREATE_DM_SUCCESS, navigateToDirectMessage);
}
